<script>
export default {
    name: "ConfirmInitiateStockTakeModal",

    data() {

        return {
            stockTakeItems:[],
            invoice: {
              description: ``,
              ref: `Advance Stock Take`,
            },
        };
    },

    props: {
        stockItems: Array,
        storeID: Number,
        showModal: Boolean,
    },

    computed: {

        advancestocktake() {

            return {
            stockTakeItems: this.stockItems,
            storeID: this.storeID,
            date: window.moment().format(`YYYY-MM-DD`),
              userName: this.$root.username,
              description:`Advance Stock Take`
            };
        },
 
    },

    methods: {

        saveData() {
          this.$root.loading = true;
            this.$http.post(`StockTake/AddStockTakeAdvance`, this.advancestocktake).then(response => {
                this.$root.loading = false;
                this.$emit('closeModal');
                this.$emit('refresh');
                window.Swal.fire({ type: 'success', title: response.data});
            }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });

            // this.$root.loading = true;
            // this.$http.post(`StockTake/AddStockTakeAdvance`, this.advancestocktake).then(() => {
            //     this.$root.loading = false;
            //     this.$emit('closeModal');
            //     this.$emit('refresh');
            //    window.Swal.fire({ type: 'success', title: response.data});
            // }).catch(() => { this.$root.loading = false; this.$emit('closeModal'); });
        },
    },
}
</script>
<template>
    <tail-modal :show="showModal" dimension="md:w-1/3 sm:w-11/12">
      <template v-slot:title>
        <h5 class="font-bold text-sm">Initiate Stock Take</h5>
      </template>
      <template v-slot:modal-body>
        <div class="w-full text-center -m-3">
            <h5 class="font-medium text-base">Confirm Initiate Stock Take.</h5>
        </div>
      </template>
      <template v-slot:modal-footer>
        <button 
          class="btn-danger btn-sm text-xs mr-4" 
          @click.prevent="$emit(`closeModal`)">
            <i class="fa fa-times"></i> Cancel</button>
        <button 
          class="btn-primary btn-sm text-xs" 
          @click.prevent="saveData">
            <i class="fa fa-save"></i> Initiate Stock Take</button>
      </template>
    </tail-modal>
</template>
